import 'swiper/css';
import 'swiper/css/thumbs';
import 'swiper/css/free-mode';

import React from 'react';

import { IProduct } from '@/models';
import BreadCrumbs from '@/components/v2/BreadCrumbs';

interface Props {
  product: IProduct;
}

import G100206 from './G100206';
import Gallery from './Gallery';
import ColorPicker from './ColorPicker';
import SizePicker from './SizePicker';
import Details from './Details';

import Delivery from './Delivery';
import { ProductStoreProvider } from '../store';
import AddToCart from './AddToCart';
import AccordionSection from './AccordionSection';
import Characteristics from './Characteristics';
import RestockForm from './RestockForm';

const Overview: React.FC<Props> = ({ product }) => {
  return (
    <ProductStoreProvider product={product}>
      <section className="section grid sm:gap-8 md:gap-16 xl:grid-cols-2 pt-0 lg:pt-16">
        <div className="space-y-8 xl:h-min xl:sticky xl:top-0">
          <Gallery />
          <AccordionSection containerClassName="hidden xl:block" />
        </div>

        <div
          id="product-options"
          className="space-y-6 xl:h-min xl:sticky xl:top-0"
        >
          <G100206 />

          <BreadCrumbs
            data={product.breadcrumbs}
            containerClassName="hidden md:flex"
          />

          <ColorPicker containerClassName="lg:hidden" />

          <Details />

          <ColorPicker containerClassName="hidden lg:block" />

          <SizePicker />
          <RestockForm />
          <AddToCart />
          <Delivery
            madeIn={product.made_in ? product.made_in.toLowerCase() : ''}
          />
          <Characteristics />
          <AccordionSection containerClassName="xl:hidden" />
        </div>
      </section>
    </ProductStoreProvider>
  );
};

export default Overview;
